export { default } from './PointIcon';
